import React, { useState, useEffect } from 'react';
import './MIUserCard.css';
import SelectInput from '../SelectInput/SelectInput';
import { format, parseISO } from 'date-fns';
import logComponent from '../../common/logComponent';

export default function MIUserCard({ miUser }) {
  const [accessLevel, setAccessLevel] = useState(miUser.isAdmin === true ? 'Admin' : miUser.isAdmin === false ? 'Standard' : '');
  const { monitoredIndividual } = miUser;

  const monitoredIndividualName = `${monitoredIndividual.legalFirstName} ${!!monitoredIndividual.preferredFirstName ? '(' + monitoredIndividual.preferredFirstName + ')' : ''} ${monitoredIndividual.lastName}`;


  if (logComponent('MIUserCard')) { console.debug('MIUserCard rendered'); }

  useEffect(() => {
    if (logComponent('MIUserCard')) { console.debug('MIUserCard useEffect [miUser.IsAdmin]'); }
    let accessLevel = miUser.isAdmin === true ? 'Admin' : miUser.isAdmin === false ? 'Standard' : '';
    setAccessLevel(accessLevel);
  }, [miUser.IsAdmin])

  const setAccessLevelThis = (newLevel) => {
    if (logComponent('MIUserCard')) { console.debug('MIUserCard setAccessLevelThis'); }
    setAccessLevel(newLevel);

    switch (newLevel) {
      case 'Admin':
        miUser.isAdmin = true;
        break;
      case 'Standard':
        miUser.isAdmin = false;
        break;
      default: 
        miUser.isAdmin = null;
        break;
    }

    forceUpdate();
  }

  const forceUpdate = () => {
    if (logComponent('MIUserCard')) { console.debug('MIUserCard forceUpdate'); }
   //TODO:  What to put here.  Method was missing
  }

  const getRoomNumbers = () => {
    if (logComponent('MIUserCard')) { console.debug('MIUserCard getRoomNumbers'); }

    let roomNumbers = [];
    if (miUser.monitoredIndividual.monitoredIndividualUnits) {
      roomNumbers = miUser.monitoredIndividual.monitoredIndividualUnits.map(individualUnit => individualUnit.unit.name);
    }
    
    return roomNumbers;
  }
  const roomNumbers = getRoomNumbers();


  return (
    <div className="MI-User-Card">
      <p className="MI-User-Card__name">{monitoredIndividualName}</p>
          <p className="MI-User-Card__info">
              {
                  monitoredIndividual.dateOfBirth != null &&
                  <span className="MI-User-Card__dob">{format(parseISO(monitoredIndividual.dateOfBirth), 'MMM d, yyyy')}</span>
              }
        {
          roomNumbers.length > 0 &&
          <React.Fragment>
            <span className="MI-User-Card__dot">{' \u2022 '}</span>
            <span className="MI-User-Card__info">{roomNumbers.join(', ')}</span>
          </React.Fragment>
        }
      </p>
      <SelectInput
        label="Access Level"
        name="accessLevel"
        items={['', 'Standard', 'Admin']}
        showError={miUser.needsAccessLevel}
        errorMessage="Please select an access level"
        rules={{ required: true }}
        size="small"
        initialValue={accessLevel}
        onSelect={setAccessLevelThis}
        style={{ width: '300px', maxWidth: '75%', paddingBottom: 0 }} />
      <p className={'MI-User-Card__reminder' + (accessLevel || !miUser.selected ? ' MI-User-Card__reminder--hidden' : '')}>Remember to select the access level!</p>
    </div>
  );
}

